import {defineStore} from 'pinia';
import {ModuleCommercialBank} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';

/**
 * Store ngân hàng thương mại
 */
import commercialBankAPI from '@/apis/di/commercialBankAPI';
const commercialBankStore = new BaseDictionaryStore(commercialBankAPI);
export const useCommercialBankStore = defineStore(ModuleCommercialBank, {
  state: () => ({
    ...commercialBankStore.state,
    _config: {
      key: 'commercial_bank_id',
      code: 'commercial_bank_code',
      name: 'commercial_bank_name',
      table: 'di_commercial_bank',
      moduleName: 'Ngân hàng thương mại',
      quickFollow: 'active',
      defaultSort: 'sort_order',
    },
    moduleName: 'diCommercialBank',
  }),
  actions: {
    ...commercialBankStore.action,
  },
  getters: {
    ...commercialBankStore.getters,
  },
});
